import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Button from '../../components/common/Button/Button';
import Input from '../../components/common/Input/Input';
import { newsCategoryService } from '../../services/newsCategoryService';
import styles from './NewsCategory.module.css';

const NewsCategoryForm = ({ isOpen, onClose, categoryToEdit, refreshData }) => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (categoryToEdit) {
            setName(categoryToEdit.name);
        } else {
            setName('');
        }
    }, [categoryToEdit]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            toast.error("Category Name is required");
            return;
        }

        setLoading(true);
        try {
            if (categoryToEdit) {
                await newsCategoryService.update(categoryToEdit.id, { name });
                toast.success('Category updated successfully');
            } else {
                await newsCategoryService.create({ name });
                toast.success('Category created successfully');
            }
            refreshData();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h3>{categoryToEdit ? 'Edit Category' : 'Add New Category'}</h3>
                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label>Name</label>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter Category Name"
                        />
                    </div>
                    <div className={styles.modalActions}>
                        <Button variant="secondary" onClick={onClose} type="button">Cancel</Button>
                        <Button type="submit" disabled={loading}>
                            {loading ? 'Saving...' : (categoryToEdit ? 'Update' : 'Create')}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewsCategoryForm;
